export default __webpack_public_path__ + "static/media/webBottomHover.ed769c1c.png";